import { render, staticRenderFns } from "./DashboardTop.vue?vue&type=template&id=61407265&scoped=true&"
import script from "./DashboardTop.vue?vue&type=script&lang=js&"
export * from "./DashboardTop.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTop.vue?vue&type=style&index=0&id=61407265&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61407265",
  null
  
)

export default component.exports